import Vue from "vue";
import Router from "vue-router";
import HomePage from "./../components/MainPage.vue";
import ServicesMaintenance from "./../components/ServicesMaintenance.vue";
import ServicesDisaster from "./../components/ServicesDisaster.vue";
import ServicesConstruction from "./../components/ServicesConstruction.vue";
import About from "./../components/About.vue";
import Contact from "./../components/Contact.vue";

Vue.use(Router);

export default new Router({
  routes: [
    { path: "/", component: HomePage },
    { path: "/home", component: HomePage },
    { path: "/services_maintenance", component: ServicesMaintenance },
    { path: "/services_disaster_relief", component: ServicesDisaster },
    { path: "/services_construction", component: ServicesConstruction },
    { path: "/about", component: About },
    { path: "/contact", component: Contact },
  ],
});
